import * as Yup from 'yup';


const conatctvalidationSchema = Yup.object({
  fullName: Yup.string().required('Full Name is required'),
  email: Yup.string().email('Invalid email format').required('Email is required'),
  phoneNumber: Yup.string().required('Phone number is required'),
  subject: Yup.string().required('Subject is required'),
  comment: Yup.string().required('Comment is required'),
});

export default conatctvalidationSchema;